<template>
  <div :class="personClass" @click="personClick">
    <div v-if="!hideImg" class="person-image">
      <div class="inner-person-image">
        <img :src="imgSrc" class="front" />
        <img v-if="showPresence" :src="imgSrc" class="back" />
      </div>
      <div
        v-if="action.icon"
        @click="action.event(action, person)"
        class="action-button"
      >
        <fa-icon :icon="action.icon" size="xs" />
      </div>
    </div>
    <p v-if="!hideName" class="person-name">
      {{ showFullName ? person.name : displayName }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'Person',
  props: {
    person: Object,
    hideName: Boolean,
    hideImg: Boolean,
    showPresence: Boolean,
    showFullName: Boolean,
    action: {
      type: Object, // action{ event(action, person), icon{ type, name }@opt }
      default: () => ({ event: null, icon: null }),
    },
  },
  computed: {
    imgSrc() {
      return this.$store.getters.imgPath(this.person.imgFileName);
    },
    personClass() {
      let classList = [];
      classList.push('person');
      this.showPresence && classList.push('grayscale');
      this.person.present && classList.push('present');
      this.action.event && !this.action.icon && classList.push('hover-effect');
      return classList.join(' ');
    },
    displayName() {
      const trimmedName = this.person.name.trim();
      const chars = '\\wäöüÄÖÜß';
      let displayName = trimmedName.replace(
        new RegExp(`( [${chars}])[${chars}]+$`),
        '$1'
      );
      // if (displayName.length < trimmedName.length) {
      //   displayName += '.';
      // }
      return displayName;
    },
  },
  methods: {
    personClick() {
      this.action.event &&
        !this.action.icon &&
        this.action.event(this.action, this.person);
    },
  },
};
</script>

<style lang="scss">
$size-multiplier: 0.9;

.person {
  display: flex;
  flex-direction: column;
  align-items: center;

  border-radius: 5px * $size-multiplier;

  &.hover-effect:hover {
    cursor: pointer;
    background-color: rgba(#000, 0.2);
  }

  // Name
  .person-name {
    width: 95px * $size-multiplier;
    margin-bottom: 10px * $size-multiplier;
    color: white;
    overflow: hidden;
    white-space: nowrap;
    text-align: center;
    text-overflow: ellipsis;
  }

  // Image
  .person-image {
    width: 60px * $size-multiplier;
    height: 60px * $size-multiplier;

    margin: 10px * $size-multiplier;

    position: relative;
  }
  &.grayscale {
    .inner-person-image {
      transform: rotateY(180deg);
    }
    &.present .inner-person-image {
      transform: rotateY(0deg);
    }
  }
  .inner-person-image {
    position: relative;
    width: 100%;
    height: 100%;
    transition: transform 600ms;
    transform-style: preserve-3d;

    img {
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 50%;
      backface-visibility: hidden;

      object-fit: cover;
      object-position: top;

      &.back {
        filter: grayscale(100%);
        transform: rotateY(180deg);
      }
    }
  }

  .action-button {
    width: 30px;
    height: 30px;
    position: absolute;
    bottom: -13px;
    right: -13px;

    border-radius: 50%;
    background-color: $year-color;
    @include flex-center();

    &:hover {
      cursor: pointer;
      background-color: darken($year-color, 10%);
    }
  }
}
</style>
